import axios from "axios";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

const BASE_URL = process.env.REACT_APP_URL_API;
const URL_PREFIJO = process.env.REACT_APP_URL_PREFIJO;
const apiInstance = axios.create({ baseURL: `${BASE_URL}${URL_PREFIJO}` });
const header = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "ngrok-skip-browser-warning": "69420",
};
apiInstance.interceptors.request.use(
  (request) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const usuario = window.localStorage.getItem("usuario");
    if (usuario && request.method != "get") {
      request.data.createdBy = JSON.parse(usuario).userName;
      request.data.modifiedBy = JSON.parse(usuario).userName;
    }
    const autorization = {
      Authorization: accessToken ? "Bearer " + accessToken : "",
    };
    request.headers = {
      ...header,
      ...autorization,
    };
    return request;
  },
  (err) => err
);

apiInstance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    try {
      const originalError = error.response;
      const originalRequest = error.config;
      if (originalError?.status === 401) {
        originalRequest._retry = true;
        window.localStorage.clear();
        window.localStorage.setItem("accessToken", null);
        window.localStorage.setItem("usuario", null);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("usuario");
        history.push("/");
        location.reload();
        return apiInstance(originalRequest);
      }
      if (originalError) {
        return Promise.reject(originalError);
      } else {
        const newIs = {
          data: {
            reason: "User Exists",
            message: "Error",
          },
          status: 400,
          statusText: "",
          headers: {
            "content-length": "106",
            "content-type": "application/json; charset=utf-8",
          },
          config: {
            transitional: {
              silentJSONParsing: true,
              forcedJSONParsing: true,
              clarifyTimeoutError: false,
            },
            adapter: ["xhr", "http", "fetch"],
            transformRequest: [null],
            transformResponse: [null],
            timeout: 0,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            maxContentLength: -1,
            maxBodyLength: -1,
            env: {},
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "ngrok-skip-browser-warning": "69420",
              Authorization:
                "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkM4RTg5RTYzQkE5Q0NFMUJBQzEyNUFGOENENkRDREFGIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE3Mjc5Njk1MzksImV4cCI6MTcyNzk3MzEzOSwiaXNzIjoiaHR0cHM6Ly9hdXRoLmlucHNlcmNvbS5jb20iLCJhdWQiOiJodHRwczovL2F1dGguaW5wc2VyY29tLmNvbS9yZXNvdXJjZXMiLCJjbGllbnRfaWQiOiIyZmQ3M2U2NWYzMmQzZjJlYTVhNmYyZmQyMDY1MmQzYTMwOTYxYzIxMGE1MGU0ZGE2YTk2YzcxYTU4YjIxNjZkIiwic3ViIjoiNWRiYzFmNGQtNTYxNC00N2U2LTk5NmUtZGMyZWQyYmRiYjA1IiwiYXV0aF90aW1lIjoxNzI3OTY5NTM5LCJpZHAiOiJsb2NhbCIsImp0aSI6Ijg1MjdFMzkzQTk5M0FFQ0VEN0M2NzVCMTE3RTA0OTFBIiwiaWF0IjoxNzI3OTY5NTM5LCJzY29wZSI6WyJjbG9zZTpzZXNzaW9ucyIsImNyZWF0ZTpjb2RlIiwiY3JlYXRlOnBhc3N3b3JkIiwiY3JlYXRlOnNlc3Npb25zIiwiY3JlYXRlOnRyYW5zYWN0aW9uIiwiY3J1ZDphZG1pbiIsImNydWQ6YnJhbmRzIiwiY3J1ZDpjYXJkcyIsImNydWQ6Y2l0aWVzIiwiY3J1ZDpkYXRhZmFzdCIsImNydWQ6ZGV0YWlsdHJhbnNhY3Rpb24iLCJjcnVkOmRldmljZSIsImNydWQ6ZG9jdW1lbnQtdHlwZSIsImNydWQ6Z2VucmUiLCJjcnVkOmltYWdlIiwiY3J1ZDpsZWdhbC1wZXJzb24tdHlwZSIsImNydWQ6bWFyaXRhbHMiLCJjcnVkOm1vZGVscyIsImNydWQ6cGVyc29uIiwiY3J1ZDpyb2wiLCJjcnVkOnJvbC11c2VyIiwiY3J1ZDpzdGF0ZXMiLCJjcnVkOnN0YXR1cyIsImNydWQ6c3Vic2NyaXB0aW9uIiwiY3J1ZDp1c2VyIiwiY3J1ZDp2ZWhpY2xlcyIsImVtYWlsIiwib3BlbmlkIiwicHJvZmlsZSIsInJlYWQ6Y2xpZW50OmNyZWRpdC1jYXJkIiwicmVhZDp0cmFuc2FjdGlvbiIsIm9mZmxpbmVfYWNjZXNzIl0sImFtciI6WyJjdXN0b20iXX0.-GrOxW-9LRbw1rjX8QhrDJHOpN3M61ERyQwhWq9URgf-Q2qaxtlSYJl3m1YXXvR3JtjNahCoDN9jxMBSdiFzE0f57aj1p2jEwXxtVq0H2j5sQysOLbLo4yO72w-986Lr3ZA10NxCt_yxnDavqov1Vwt20Uo5ISRYmxWdNcDvuaPZ8fckwuAJcw7ApFqcSUFALAc7p3MRWiOHu2ZXL9OLk2-Xb03ekP63xvlyr7MpQ6LawSj98-72O7LIL7WDeU0vTjG1wO8U03Zv_MmKCAK0hdYATsuWl4hJg_bHp8H1DerrNRdAJV_MdRhZgCtUUA0_qGwDFdvUg5lcf4eL5DJwMg",
            },
            baseURL: "https://ev-chargers-api.inpsercom.com/",
            method: "post",
            url: "/person",
            data: '{"idDocumentType":"CfDJ8KFLj2O76G9HtakL8HgIKK2hcY-Xpr49H2jCE0HH1D-cTW6s14vfPe788Jb45_WHxKVeMM7gnXDIJI5uOaGZHXroEcNGO7dkgxv9C2kjebhqKfRn_vHJMEiJJX2R8oCyXQ","firstName":"inpsercom","middleName":"0504274705","lastName":"0504274705","secondLastName":"tecnologia","birthDate":"2024-10-03","email":"v@gmail.com","phone":123454321,"identification":"0504274705","password":"giantsteam78","idGenero":"CfDJ8KFLj2O76G9HtakL8HgIKK1Cv30fnoNQPP6r_-Hi5SvsJ4Pkdd55sgpU6Ib-w_E8EtclbhFKZ79AGRZAVYUgRoS9nTw-m6oNL53-HZ23t4HA4_kndA1lWGmhA4FecTsVbQ","idLegalPersonType":"CfDJ8KFLj2O76G9HtakL8HgIKK0wwCa4lvTNC2fga_3Ji6Ve4cn9-TwHPlJvzxbCBWfBMk5tm2XTk1IwbB8GLqqSp3hVIhLaXJideWtNDIjgvbqp6Y7gz7ujR-VDXpO4Ip3ziw","idMaritalSatus":"CfDJ8KFLj2O76G9HtakL8HgIKK2sWo1f8AFyhIFRjAgjNiUcS-kuevl8frd2r-d0PeAD6CTWMsW6QLwXQWhrFCxIGMRInZde7q2ybhwo8GEopX9NELAZKmo9x-zy3TH63QqU7g","countryId":1,"acceptTermsConditions":true,"status":1,"createdBy":"inps","modifiedBy":"inps"}',
          },
          request: {},
        };
        console.error('newIs',newIs)
  
        return Promise.reject(newIs);
      }
    } catch (error) {
      console.error('error',error)

    }

  }
);

export default apiInstance;
